import React from "react";
import AstraImage from "../assets/astra.webp";
import WalknHomesImage from "../assets/walk.webp";

const products = [
  {
    image: AstraImage,
    title: "Astra3D",
    tagline: "No-Code Platform for Building Immersive Digital Experiences",
    description:
      "Astra3D enables businesses to create interactive virtual stores, showrooms, exhibitions, campuses, hotels, museums and digital twins without writing a single line of code.",
    features: [
      "No-code 3D editor",
      "Interactive hotspots & multimedia",
      "AI-ready virtual experiences",
      "Works across desktop, mobile & VR",
      "Built for retail, hospitality, education & more",
    ],
    link: "https://astra3d.com",
  },
  {
    image: WalknHomesImage,
    title: "WalknHomes",
    tagline: "Explore Properties Virtually Before You Visit",
    description:
      "WalknHomes is an immersive real estate platform that allows buyers to explore homes through interactive 360° virtual tours, helping them make faster and more informed decisions.",
    features: [
      "Immersive property walkthroughs",
      "360° virtual tours",
      "Verified property listings",
      "AI-powered property assistant",
      "Built for buyers, builders & brokers",
    ],
    link: "https://walknhomes.com",
  },
];

const ProductCard = ({ product }) => (
  <div className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-200 hover:shadow-2xl transition-all duration-300">
    <img
      src={product.image}
      alt={product.title}
      className="w-full h-[360px] sm:object-fill object-fit"
    />

    <div className="p-8">
      <h2
        className="text-[18px] sm:text-[22px] mb-6"
        style={{
          fontFamily: "'Antonio', sans-serif",
          fontWeight: 500,
        }}
      >
        {product.title}
      </h2>

      <p className="text-blue-600 font-semibold mb-4" style={{
          fontFamily: "'Rubik', sans-serif",
        }}>
        {product.tagline}
      </p>

      <p
        className="text-gray-700 text-[16px] leading-8 mb-6"
        style={{
          fontFamily: "'Rubik', sans-serif",
        }}
      >
        {product.description}
      </p>

      <ul className="space-y-3 text-[16px] mb-8">
        {product.features.map((feature, index) => (
          <li
            key={index}
            className="flex items-start gap-3 text-gray-700"
            style={{
              fontFamily: "'Rubik', sans-serif",
            }}
          >
            <span className="text-green-600 font-bold">✓</span>
            {feature}
          </li>
        ))}
      </ul>

      <a
        href={product.link}
        target="_blank"
        rel="noopener noreferrer"
      >
        <button className="bg-[#6486B4] hover:bg-[#4f74a8] text-white text-[16px] px-6 py-3 rounded-lg transition">
          Visit Website →
        </button>
      </a>
    </div>
  </div>
);

export const Products = () => {
  return (
    <div
      className={`bg-white  text-[16px] sm:text-[18px] text-justify w-full h-full flex justify-center items-center rounded-lg overflow-y-scroll no-scrollbar`}
    >
      <div
        className={`text-justify p-6  overflow-auto ${
          window.innerWidth > 1500 ? "max-w-[90%]" : ""
        }`}
        style={{ maxHeight: "100%" }}
      >
       <div className="mt-8 text-[20px] sm:text-[24px]">
          <p
            style={{
              fontFamily: "'Antonio', sans-serif",
              flex: "1 1 0%",
              fontWeight: "50",
              lineHeight: "1em",
              textAlign: "center",
              color: "black",
              letterSpacing: -0.3,
              whiteSpace: "nowrap",
              marginBottom: 20,
            }}
          >
            Our Products
          </p>
          </div>

        <p
          className="text-center text-[16px] max-w-4xl mx-auto text-gray-700 leading-8 mb-16"
          style={{
            fontFamily: "'Rubik', sans-serif",
          }}
        >
          Reealtech is building the future of immersive digital experiences.
          Our products combine 3D visualization, AI and digital twin technology
          to help businesses engage customers in entirely new ways.
        </p>
       <div className="grid lg:grid-cols-2 gap-10">
          {products.map((product) => (
            <ProductCard
              key={product.title}
              product={product}
            />
          ))}
        </div>
      </div>
    </div>
  );
};
